/* Om Flower cart rows.
   The free gift discount claims one unit of a paid product, and Shopify splits
   that product into two cart lines to do it. The cart template merges those
   lines into one row (data-om-keys lists the line keys behind it). Dawn updates
   quantities by line position, which breaks on split lines ("You can only add 1
   of this item"), so row changes go by line key here: increases through
   /cart/change.js (it caps at the stock on hand), decreases through
   /cart/update.js (the whole quantity on the first line, zero on the rest).
   Shopify re-splits as it needs to and the template merges the rows again. */
(function () {
  function isGift(item) {
    return item.properties && item.properties._free_gift;
  }

  function install() {
    var CartItems = customElements.get('cart-items');
    if (!CartItems || CartItems.prototype.omRowUpdates) return;
    var dawnUpdateQuantity = CartItems.prototype.updateQuantity;
    CartItems.prototype.omRowUpdates = true;

    CartItems.prototype.updateQuantity = function (line, quantity, name, variantId) {
      var input = document.getElementById('Quantity-' + line);
      if (!input || !input.dataset.omKeys) return dawnUpdateQuantity.apply(this, arguments);

      var self = this;
      var rowVariant = input.dataset.quantityVariantId;
      var keys = input.dataset.omKeys.split(',');
      var qtys = (input.dataset.omQtys || '').split(',').map(function (q) { return parseInt(q, 10) || 0; });
      var total = qtys.reduce(function (sum, q) { return sum + q; }, 0);
      var sections = this.getSectionsToRender();
      var payload = {
        sections: sections.map(function (s) { return s.section; }),
        sections_url: window.location.pathname
      };
      var url;
      if (quantity > total) {
        /* change.js caps the line at the stock on hand; update.js does not. */
        url = window.routes.cart_change_url;
        payload.id = keys[0];
        payload.quantity = qtys[0] + (quantity - total);
      } else {
        url = window.routes.cart_update_url;
        payload.updates = {};
        keys.forEach(function (key, i) {
          payload.updates[key] = i === 0 ? quantity : 0;
        });
      }

      function post(endpoint, body) {
        return fetch(endpoint, Object.assign({}, fetchConfig(), { body: JSON.stringify(body) })).then(function (r) {
          return r.json();
        });
      }

      this.enableLoading(line);
      post(url, payload)
        .then(function (state) {
          /* Asking for more than the stock on hand answers 422 with no cart, even
             though Shopify has already capped the line. Fetch the cart as it is. */
          if (state.items) return state;
          return post(window.routes.cart_update_url, { updates: {}, sections: payload.sections, sections_url: payload.sections_url });
        })
        .then(function (state) {
          self.classList.toggle('is-empty', state.item_count === 0);
          var footer = document.getElementById('main-cart-footer');
          if (footer) footer.classList.toggle('is-empty', state.item_count === 0);

          sections.forEach(function (section) {
            var host = document.getElementById(section.id);
            if (!host || !state.sections || !state.sections[section.section]) return;
            var target = host.querySelector(section.selector) || host;
            target.innerHTML = self.getSectionInnerHTML(state.sections[section.section], section.selector);
          });

          /* Compare the row's new total, not one line, with what was asked for. */
          var got = state.items
            .filter(function (i) { return !isGift(i) && String(i.variant_id) === rowVariant; })
            .reduce(function (sum, i) { return sum + i.quantity; }, 0);
          var message = quantity > 0 && got < quantity ? window.cartStrings.quantityError.replace('[quantity]', got) : '';
          var row = self.querySelector('input[data-om-keys][data-quantity-variant-id="' + rowVariant + '"]');
          self.updateLiveRegions(row ? row.dataset.index : line, message);

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state, variantId: variantId });
        })
        .catch(function () {
          self.querySelectorAll('.loading__spinner').forEach(function (el) { el.classList.add('hidden'); });
          var errors = document.getElementById('cart-errors');
          if (errors) errors.textContent = window.cartStrings.error;
        })
        .finally(function () {
          self.disableLoading(line);
        });
    };
  }

  if (customElements.get('cart-items')) install();
  else customElements.whenDefined('cart-items').then(install);
})();
